import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { setTicketConfigSelectedTicketType } from "../../../../../app/slices/TicketEasyModuleSlice";
import { useTicketTypeConfigSearchQuery } from "../../../../../services/ticketEasyService/ticketEasy-api";
import { TicketTypeConfigSearchRequest } from "../../../../../services/ticketEasyService/commands/TicketTypeConfigSearchRequest";
import { setTicketTypeConfigList, setTicketTypeConfig } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketTypeConfig/TicketTypeConfigSlice";
import { TicketTypeDropdown } from "./TicketTypeDropdown";

function TicketTypeSelect() {
  const dispatch = useAppDispatch();
  const selectedModule = useAppSelector((state) => state.ticketEasyModule.TicketConfigSelectedModule);
  const ticketTypeConfigList = useAppSelector((state) => state.ticketTypeConfig.ticketTypeConfigList);
  const [skip, setSkip] = useState(true);

  useEffect(() => {
    setSkip(!selectedModule);
  }, [selectedModule]);

  const command = useMemo(() => new TicketTypeConfigSearchRequest(selectedModule, ""), [selectedModule]);
  const { data } = useTicketTypeConfigSearchQuery(command, { skip });

  useEffect(() => {
    if (data && data !== ticketTypeConfigList) {
      dispatch(setTicketTypeConfigList(data || []));
    }
  }, [data, ticketTypeConfigList, dispatch]);

  const handleTicketTypeSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const selectedTicketTypeConfig = ticketTypeConfigList.find((config) => config.ticketType === value);
    if (selectedTicketTypeConfig) {
      dispatch(setTicketConfigSelectedTicketType(selectedTicketTypeConfig.ticketType));
      dispatch(setTicketTypeConfig(selectedTicketTypeConfig));
    }
  }, [ticketTypeConfigList, dispatch]);

  return (
    <Grid item xs={11}>
      <TicketTypeDropdown
        ticketTypeConfigList={ticketTypeConfigList}
        handleTicketTypeSelect={handleTicketTypeSelect}
        selectedModule={selectedModule}
      />
    </Grid>
  );
}

export { TicketTypeSelect };
